import { type ReactNode } from 'react';

import { Button, Stack } from '@mui/material';
import { Trans } from 'react-i18next';

import { Icon } from '../../../../../components/base';
import { FilterButton } from '../../../../../components/ControlPanel/components/FilterButton';
import { WrapperBox } from '../../../../../components/ControlPanel/components/WrapperBox';
import { FullScreenButton } from '../../../../../components/FullScreen';
import { Drawer, useShowDrawer } from '../../../../../state/drawer';
import { AddIncidentControl } from './components/AddIncidentControl';
import { AdvancedMenuIncident } from './components/AdvancedMenuIncident';
import { FlaggedControl } from './components/FlaggedControl';
import { SearchInputPanel } from './components/SearchInputPanel';
import { UnreadControl } from './components/UnreadControl';

type Props = {
  fontSizeControl?: ReactNode;
};

export const ControlPanel = ({ fontSizeControl }: Props) => {
  const { execute: showDrawer } = useShowDrawer();

  return (
    <WrapperBox>
      <AddIncidentControl />

      <Stack direction='row' spacing='8px' sx={{ flexWrap: 'wrap' }}>
        <UnreadControl />
        <FlaggedControl />
        <SearchInputPanel />
        <FilterButton onClick={() => showDrawer({ type: Drawer.INCIDENT_FILTER })} />
        <Button
          variant='outlined'
          color='inherit'
          sx={{ borderColor: '#C7D1D4', height: '40px', fontWeight: 400 }}
          onClick={() => showDrawer({ type: Drawer.INCIDENT_TABLE_COLUMNS })}
        >
          <Trans i18nKey='columns' />
          <Icon icon='showColumn' htmlColor='#C7D1D4' sx={{ width: '17px', height: '17px', marginLeft: '10px' }} />
        </Button>
        {fontSizeControl}
        <FullScreenButton />
        <AdvancedMenuIncident />
      </Stack>
    </WrapperBox>
  );
};
